import { handleZipFileUpload } from 'api/bulkWorkflow';
import Label from 'lib/Label';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

const ZipFileUploader = ({ label, tooltip, validators, label_style, size, custom_styles }) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const onDrop = (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file && file.type === 'application/zip') {
          setUploadedFile(file);
          handleUploadedFile(file); 
      } else {
          setUploadStatus('Please upload a valid ZIP file.');
      }
  };
  
  const handleUploadedFile = async (file) => {
      try {
          const response = await handleZipFileUpload(file); 
          if (response.status === "Success") {
              setUploadStatus('Upload successful!');
          } else {
              setUploadStatus('Upload failed:' + response.message);
          }
      } catch (error) {
          setUploadStatus('Error uploading file.');
          console.error("Error during upload:", error);
      }
  };
    const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: { 'application/zip': [] } });
    const removeFile = () => {
        setUploadedFile(null);
        setUploadStatus('');
    };

    return (
        <>
            <Label
                image={true}
                htmlFor="upload"
                label={label}
                tooltip={tooltip}
                validators={validators}
                className={label_style}
            />
            <div className={size}>
                {uploadedFile ? (
                    <div className="file-uploaded">
                        <div className="upload-container ps-1">
                            <p className="mb-0 fs-12px">{uploadedFile.name}</p>
                            <span className="fs-10px">{(uploadedFile.size / (1024 * 1024)).toFixed(2)} MB</span>
                            <button
                                aria-label={`Remove ${uploadedFile.name}`}
                                className={`remove_button ${isDisabled ? "disabled" : ""}`}
                                disabled={isDisabled}
                                onClick={removeFile}
                            >
                                Remove
                            </button>
                        </div>
                        <p className="upload-status">{uploadStatus}</p>
                    </div>
                ) : (
                    <div className={`${custom_styles} file-uploader`}>
                        <div {...getRootProps({ className: "dropzone" })}>
                            <input {...getInputProps()} />
                            <p>Drag and drop or <span className="pe-auto">browse</span> to upload a .zip file</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ZipFileUploader;
